import { defineStore } from 'pinia';
import { fetchCryptoCurrencies } from '@/js/store/currency-converter/services/api';
import { CryptoCurrencyType } from '@/js/cryptocurrencies/types/cryptocurrencyType';

interface CurrencyConverterStoreState {
    cryptoCurrencies: CryptoCurrencyType[] | null;
    loading: boolean;
    page: number;
    isCryptoCurrenciesDataFetchCompleted: boolean;
    totalItems: number;
}

export const useCurrencyConverterStore = defineStore('CurrencyConverterStore', {
    state: (): CurrencyConverterStoreState => ({
        cryptoCurrencies: null,
        loading: false,
        page: 1,
        isCryptoCurrenciesDataFetchCompleted: false,
        totalItems: null,
    }),
    actions: {
        async fetchCryptoCurrencies({ search = '', page = 1, perPage = 20 }: { search?: string, page?: number, perPage?: number } = {}) {
            if (this.loading) return;
            this.loading = true;

            try {
                const response = await fetchCryptoCurrencies({ search, page, perPage });

                if (page === 1) {
                    this.cryptoCurrencies = response.data;
                } else {
                    this.cryptoCurrencies.push(...response.data);
                }

                this.page = page;
                this.totalItems = response.meta?.total;
            } finally {
                this.loading = false;
                this.isCryptoCurrenciesDataFetchCompleted = true;
            }
        },
    },
});
